import { render, staticRenderFns } from "./infoUser.vue?vue&type=template&id=280461b5&scoped=true&"
import script from "./infoUser.vue?vue&type=script&lang=js&"
export * from "./infoUser.vue?vue&type=script&lang=js&"
import style0 from "./infoUser.vue?vue&type=style&index=0&id=280461b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280461b5",
  null
  
)

export default component.exports